import React, { memo, useState } from 'react';
import projectsData from "../data/projects.json";
import ProjectRow from './ProjectRow';
import ProjectsImg from "../img/icons/projects-icon-small.webp";
import { animated, useSpring } from 'react-spring';
import ProjectBox from './ProjectBox';

function ProjectsSection() {
    const [curDisplayStyle] = useState("table")
    const projectRows = [];
    for (let entry of projectsData) {
        if (!Object.hasOwn(entry, 'ignore')) {
            projectRows.push(
            <ProjectRow
                title={entry.title}
                authors={entry.authors}
                venue={entry.venue}
                projType={entry.projType}
                //titleLink={entry.titleLink}
                otherLinks={entry.otherLinks}
                projImg={entry.projImg}
                projImgAlt={entry.projImgAlt}
                key={"pub-" + entry.title}/>
            );
        }
    }
    const projectBoxes = [];
    let boxCount = 1;
    for (let entry of projectsData) {
        projectBoxes.push(
        <ProjectBox
            fadeInDelay={150 * boxCount}
            shortTitle={entry.shortTitle}
            projImg={entry.projImg}
            projImgAlt={entry.projImgAlt}
            key={"pub-" + entry.title}/>
        );
        boxCount += 1;
    }

    const sp2 = useSpring({
        opacity: 1,
        transform: "translateY(0px)",
        from: { opacity: 0 }, /*, transform: "translateY(-20px)" },*/
        delay: 200
    });

    return (
        <animated.section style={sp2} id="projects-section" aria-label="About me">
            <div className='section-header'>
                <div id="projects-header">
                    <div>
                        <h1>Projects</h1>
                        {/*<img src={ProjectsImg} alt={"messy line art of a stack of books"}/>*/}
                    </div>
                    {/*<DisplayButton onBtnClick={displayOptionsOnClick} setDisplayStyle={setDisplayStyle}/>*/}
                </div>
                <div className="border-scribble"></div>
            </div>
            <table>
                <thead className='sr-only'>
                    <tr>
                        <th scope='col'><span>Thumbnail</span></th>
                        {/*<th scope='col'><span>Type</span></th>*/}
                        <th scope='col'><span>Venue</span></th>
                        <th scope='col'><span>Title</span></th>
                        <th scope='col'><span>Authors</span></th>
                        <th scope='col'><span>Links</span></th>
                    </tr>
                </thead>
                <tbody>
                    {projectRows}
                </tbody>
            </table>
        </animated.section>
    );
}

export default memo(ProjectsSection)